
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.308 17.399H6.692a1.081 1.081 0 01-.944-.669L1.953 6.115c-.541-1.522.091-1.99 1.393-1.055l3.575 2.56a.966.966 0 001.531-.47l1.613-4.3c.513-1.375 1.366-1.375 1.879 0l1.615 4.3a.959.959 0 001.52.47l3.355-2.393c1.43-1.027 2.118-.5 1.531 1.155l-3.706 10.366a1.12 1.12 0 01-.951.651z","fill":"none","stroke":"#fed029","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M5.958 20.167h10.083M8.708 12.833h4.583","fill":"none","stroke":"#fed029","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","opacity":".34"}})])
          )
        }
      }
    